import wretch from 'wretch';
import FormDataAddon from 'wretch/addons/formData';

export const AJAX_API = wretch(
  `${window.location.origin}/wp/wp-admin/admin-ajax.php`,
).addon(FormDataAddon);
